import { useState } from "react";
import React from 'react';

const copy = {
  en: {
    brandSub: "AI Business Studio",
    navServices: "Services",
    navApproach: "Approach",
    navWork: "Work",
    navContact: "Contact",
    contactBtn: "Let’s Talk",
    heroTag: "Build · Deploy · Monetize",
    heroTitleLine1: "We turn AI ideas into",
    heroTitleLine2: "real business value.",
    heroDesc:
      "SALELARY helps startups and enterprises launch practical AI services through consulting, software development, LLM implementation, and hands-on education.",
    heroPrimary: "Explore Services",
    heroSecondary: "View Sample Work",
    badge1Title: "AI Consulting",
    badge1Sub: "LLM, RAG, Agents",
    badge2Title: "Custom Development",
    badge2Sub: "Web · App · Cloud",
    badge3Title: "Training Programs",
    badge3Sub: "Workshops · Education",
    panelTitle: "AI Business Studio",
    panelCoreLabel: "Core Positioning",
    panelCoreTitle: "From strategy to shipping",
    panelCoreDesc:
      "We bridge consulting and execution so that AI does not remain a concept deck.",
    panelAudience: "Startups & Enterprises",
    panelAreas: "Consulting · Dev · Education",
    panelBrandLabel: "Brand message",
    panelBrandText: "Technology that sells, scales, and sustains.",
    servicesLabel: "Services",
    servicesTitle: "Practical offerings for companies that need results.",
    servicesDesc:
      "From external projects to AI strategy sessions, SALELARY supports both immediate execution and longer-term transformation.",
    service1Title: "AI & LLM Consulting",
    service1Desc:
      "LLM strategy, RAG architecture, agent workflows, and practical AI roadmaps for startups and enterprises.",
    service2Title: "Product & App Development",
    service2Desc:
      "Web, app, backend, and cloud development for teams that need fast execution and production-ready delivery.",
    service3Title: "Training & Workshops",
    service3Desc:
      "Executive briefings, developer education, and AI adoption workshops tailored to real business teams.",
    serviceCta: "Tailored for your business →",
    approachLabel: "Approach",
    approachTitle: "We combine business understanding with technical execution.",
    approachDesc:
      "SALELARY is positioned between consulting and delivery. We help clients define what matters, then build what works.",
    principle1Title: "Business-first thinking",
    principle1Desc:
      "We begin from the customer’s real business goal, not from technology hype.",
    principle2Title: "Fast and practical execution",
    principle2Desc:
      "We move quickly with lean execution, prototypes, and production-oriented delivery.",
    principle3Title: "AI that works in the real world",
    principle3Desc:
      "We focus on applied AI that improves operations, products, or customer experience.",
    principle4Title: "Flexible support",
    principle4Desc:
      "Our model adapts to different client sizes, budgets, and organizational maturity.",
    workLabel: "Selected Work",
    workTitle: "A flexible partner for modern digital projects.",
    workNote: "Representative cases can be refined later with real client references.",
    case1Title: "Enterprise AI Enablement",
    case1Desc:
      "Designed AI use cases and implementation plans for large organizations exploring LLM-based transformation.",
    case2Title: "Custom Application Build",
    case2Desc:
      "Delivered tailored systems and backend services for clients needing rapid digital product execution.",
    case3Title: "AI Education Programs",
    case3Desc:
      "Led practical sessions on prompt design, programming, and applied AI for teams and communities.",
    ctaLabel: "Brand Statement",
    ctaTitle: "SALELARY helps businesses turn technology into momentum.",
    ctaDesc:
      "Whether you need an AI advisor, a reliable development partner, or a workshop for your team, we build with clarity and deliver with speed.",
    ctaBtn: "Start a Project",
    footerDesc:
      "AI consulting, software development, and education for organizations that want practical outcomes.",
    footerAvailability: "Available for consulting, project delivery, and workshops",
  },
  ko: {
    brandSub: "AI 비즈니스 스튜디오",
    navServices: "서비스",
    navApproach: "접근 방식",
    navWork: "주요 사례",
    navContact: "문의",
    contactBtn: "문의하기",
    heroTag: "구축 · 배포 · 수익화",
    heroTitleLine1: "AI 아이디어를",
    heroTitleLine2: "실제 비즈니스 가치로 만듭니다.",
    heroDesc:
      "SALELARY는 스타트업과 대기업이 컨설팅, 소프트웨어 개발, LLM 구축, 실전형 교육을 통해 실질적인 AI 서비스를 빠르게 실행할 수 있도록 돕습니다.",
    heroPrimary: "서비스 보기",
    heroSecondary: "예시 작업 보기",
    badge1Title: "AI 컨설팅",
    badge1Sub: "LLM · RAG · 에이전트",
    badge2Title: "맞춤형 개발",
    badge2Sub: "웹 · 앱 · 클라우드",
    badge3Title: "교육 프로그램",
    badge3Sub: "워크숍 · 강연",
    panelTitle: "AI 비즈니스 스튜디오",
    panelCoreLabel: "핵심 포지셔닝",
    panelCoreTitle: "전략에서 실행까지",
    panelCoreDesc:
      "AI가 기획안에 머무르지 않도록, 컨설팅과 실행을 하나로 연결합니다.",
    panelAudience: "스타트업 · 대기업",
    panelAreas: "컨설팅 · 개발 · 교육",
    panelBrandLabel: "브랜드 메시지",
    panelBrandText: "기술을 팔리고, 확장되고, 지속되는 가치로 만듭니다.",
    servicesLabel: "서비스",
    servicesTitle: "결과가 필요한 기업을 위한 실질적인 서비스",
    servicesDesc:
      "IT 외주부터 AI 전략 수립, 교육과 워크숍까지 SALELARY는 즉시 실행 가능한 지원과 장기적인 전환을 함께 제공합니다.",
    service1Title: "AI · LLM 컨설팅",
    service1Desc:
      "스타트업과 기업을 위한 LLM 전략, RAG 아키텍처, 에이전트 워크플로우, 실전형 AI 로드맵을 설계합니다.",
    service2Title: "프로덕트 · 앱 개발",
    service2Desc:
      "빠른 실행과 운영 가능한 결과물이 필요한 팀을 위해 웹, 앱, 백엔드, 클라우드 개발을 제공합니다.",
    service3Title: "교육 · 워크숍",
    service3Desc:
      "임원 브리핑, 개발자 교육, 조직 맞춤형 AI 도입 워크숍을 제공합니다.",
    serviceCta: "비즈니스에 맞게 제안합니다 →",
    approachLabel: "접근 방식",
    approachTitle: "비즈니스 이해와 기술 실행을 함께 가져갑니다.",
    approachDesc:
      "SALELARY는 컨설팅과 개발 실행의 중간 지점에 있습니다. 고객이 무엇을 우선해야 하는지 정의하고, 실제로 작동하는 결과물을 만듭니다.",
    principle1Title: "비즈니스 우선 사고",
    principle1Desc:
      "기술 트렌드보다 고객의 실제 사업 목표에서 출발합니다.",
    principle2Title: "빠르고 실용적인 실행",
    principle2Desc:
      "린한 방식으로 빠르게 움직이며, 프로토타입부터 운영형 결과물까지 연결합니다.",
    principle3Title: "현실에서 작동하는 AI",
    principle3Desc:
      "운영, 제품, 고객 경험을 실제로 개선하는 응용 AI에 집중합니다.",
    principle4Title: "유연한 지원 방식",
    principle4Desc:
      "고객 규모, 예산, 조직 성숙도에 맞춰 협업 방식을 조정합니다.",
    workLabel: "주요 사례",
    workTitle: "현대적인 디지털 프로젝트를 위한 유연한 파트너",
    workNote: "향후 실제 고객 사례와 레퍼런스로 더 구체화할 수 있습니다.",
    case1Title: "엔터프라이즈 AI 전환 지원",
    case1Desc:
      "대규모 조직의 LLM 기반 전환을 위한 AI 활용 시나리오와 실행 계획을 설계했습니다.",
    case2Title: "맞춤형 애플리케이션 구축",
    case2Desc:
      "빠른 디지털 제품 실행이 필요한 고객을 위해 맞춤형 시스템과 백엔드 서비스를 구축했습니다.",
    case3Title: "AI 교육 프로그램",
    case3Desc:
      "팀과 커뮤니티를 대상으로 프롬프트 설계, 프로그래밍, 응용 AI 중심의 실전 교육을 진행했습니다.",
    ctaLabel: "브랜드 스테이트먼트",
    ctaTitle: "SALELARY는 기술을 사업의 추진력으로 바꿉니다.",
    ctaDesc:
      "AI 자문이 필요하든, 믿을 수 있는 개발 파트너가 필요하든, 혹은 팀 교육이 필요하든 명확하게 설계하고 빠르게 실행합니다.",
    ctaBtn: "프로젝트 시작하기",
    footerDesc:
      "실질적인 성과를 원하는 조직을 위한 AI 컨설팅, 소프트웨어 개발, 교육 서비스를 제공합니다.",
    footerAvailability: "컨설팅, 프로젝트 수행, 워크숍 진행 가능",
  },
};

const services = {
  en: [
    {
      title: copy.en.service1Title,
      desc: copy.en.service1Desc,
    },
    {
      title: copy.en.service2Title,
      desc: copy.en.service2Desc,
    },
    {
      title: copy.en.service3Title,
      desc: copy.en.service3Desc,
    },
  ],
  ko: [
    {
      title: copy.ko.service1Title,
      desc: copy.ko.service1Desc,
    },
    {
      title: copy.ko.service2Title,
      desc: copy.ko.service2Desc,
    },
    {
      title: copy.ko.service3Title,
      desc: copy.ko.service3Desc,
    },
  ],
};

const principles = {
  en: [
    { title: copy.en.principle1Title, desc: copy.en.principle1Desc },
    { title: copy.en.principle2Title, desc: copy.en.principle2Desc },
    { title: copy.en.principle3Title, desc: copy.en.principle3Desc },
    { title: copy.en.principle4Title, desc: copy.en.principle4Desc },
  ],
  ko: [
    { title: copy.ko.principle1Title, desc: copy.ko.principle1Desc },
    { title: copy.ko.principle2Title, desc: copy.ko.principle2Desc },
    { title: copy.ko.principle3Title, desc: copy.ko.principle3Desc },
    { title: copy.ko.principle4Title, desc: copy.ko.principle4Desc },
  ],
};

const cases = {
  en: [
    { title: copy.en.case1Title, desc: copy.en.case1Desc },
    { title: copy.en.case2Title, desc: copy.en.case2Desc },
    { title: copy.en.case3Title, desc: copy.en.case3Desc },
  ],
  ko: [
    { title: copy.ko.case1Title, desc: copy.ko.case1Desc },
    { title: copy.ko.case2Title, desc: copy.ko.case2Desc },
    { title: copy.ko.case3Title, desc: copy.ko.case3Desc },
  ],
};

export default function SalelaryLandingPage() {
  const [lang, setLang] = useState("ko");
  const c = copy[lang];
  
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <header className="sticky top-0 z-30 border-b border-slate-200/80 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
          <div className="flex items-center gap-3">
            <div className="text-2xl font-black tracking-tight text-indigo-950">SALELARY</div>
            <div className="hidden text-xs uppercase tracking-[0.24em] text-slate-500 md:block">
              {c.brandSub}
            </div>
          </div>

          <nav className="hidden items-center gap-8 text-sm text-slate-600 md:flex">
            <a href="#services" className="transition hover:text-slate-950">{c.navServices}</a>
            <a href="#approach" className="transition hover:text-slate-950">{c.navApproach}</a>
            <a href="#cases" className="transition hover:text-slate-950">{c.navWork}</a>
            <a href="#contact" className="transition hover:text-slate-950">{c.navContact}</a>
          </nav>

          <div className="flex items-center gap-3">
            <div className="inline-flex rounded-full border border-slate-200 bg-slate-50 p-1">
              <button
                type="button"
                onClick={() => setLang("ko")}
                className={`rounded-full px-3 py-1.5 text-xs font-semibold transition ${
                  lang === "ko" ? "bg-indigo-950 text-white" : "text-slate-600"
                }`}
              >
                KR
              </button>
              <button
                type="button"
                onClick={() => setLang("en")}
                className={`rounded-full px-3 py-1.5 text-xs font-semibold transition ${
                  lang === "en" ? "bg-indigo-950 text-white" : "text-slate-600"
                }`}
              >
                EN
              </button>
            </div>
            <a
              href="#contact"
              className="rounded-full bg-indigo-950 px-5 py-2.5 text-sm font-medium text-white shadow-sm transition hover:-translate-y-0.5"
            >
              {c.contactBtn}
            </a>
          </div>
        </div>
      </header>

      <main>
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(79,70,229,0.12),transparent_35%),radial-gradient(circle_at_80%_20%,rgba(15,23,42,0.08),transparent_25%)]" />
          <div className="relative mx-auto grid max-w-7xl gap-16 px-6 py-20 lg:grid-cols-[1.2fr_0.8fr] lg:px-10 lg:py-28">
            <div>
              <div className="mb-6 inline-flex rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-medium uppercase tracking-[0.18em] text-slate-600 shadow-sm">
                {c.heroTag}
              </div>
              <h1 className="max-w-4xl text-5xl font-black leading-tight tracking-tight text-slate-950 md:text-6xl lg:text-7xl">
                {c.heroTitleLine1}
                <span className="block text-indigo-950">{c.heroTitleLine2}</span>
              </h1>
              <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-600 md:text-xl">
                {c.heroDesc}
              </p>
              <div className="mt-10 flex flex-wrap gap-4">
                <a
                  href="#services"
                  className="rounded-full bg-indigo-950 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-indigo-950/10 transition hover:-translate-y-0.5"
                >
                  {c.heroPrimary}
                </a>
                <a
                  href="#cases"
                  className="rounded-full border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-slate-800 transition hover:-translate-y-0.5"
                >
                  {c.heroSecondary}
                </a>
              </div>
              <div className="mt-12 grid max-w-2xl grid-cols-1 gap-4 sm:grid-cols-3">
                {[
                  [c.badge1Title, c.badge1Sub],
                  [c.badge2Title, c.badge2Sub],
                  [c.badge3Title, c.badge3Sub],
                ].map(([title, sub]) => (
                  <div key={title} className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
                    <div className="text-sm font-semibold text-slate-900">{title}</div>
                    <div className="mt-1 text-sm text-slate-500">{sub}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex items-center justify-center">
              <div className="w-full max-w-xl rounded-[2rem] border border-slate-200 bg-slate-950 p-6 text-white shadow-2xl shadow-slate-300/40">
                <div className="flex items-center justify-between border-b border-white/10 pb-4">
                  <div>
                    <div className="text-sm uppercase tracking-[0.18em] text-white/50">SALELARY</div>
                    <div className="mt-1 text-2xl font-bold">{c.panelTitle}</div>
                  </div>
                  <div className="rounded-full bg-white/10 px-3 py-1 text-xs text-white/70">2026</div>
                </div>
                <div className="mt-6 space-y-4">
                  <div className="rounded-2xl bg-white/5 p-5">
                    <div className="text-sm text-white/60">{c.panelCoreLabel}</div>
                    <div className="mt-2 text-lg font-semibold">{c.panelCoreTitle}</div>
                    <p className="mt-2 text-sm leading-6 text-white/70">{c.panelCoreDesc}</p>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="rounded-2xl bg-indigo-500/20 p-5">
                      <div className="text-3xl font-black">B2B</div>
                      <div className="mt-1 text-sm text-white/70">{c.panelAudience}</div>
                    </div>
                    <div className="rounded-2xl bg-white/5 p-5">
                      <div className="text-3xl font-black">AI</div>
                      <div className="mt-1 text-sm text-white/70">{c.panelAreas}</div>
                    </div>
                  </div>
                  <div className="rounded-2xl border border-white/10 p-5">
                    <div className="text-sm text-white/60">{c.panelBrandLabel}</div>
                    <div className="mt-2 text-xl font-semibold">{c.panelBrandText}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
          <div className="max-w-2xl">
            <div className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-700">{c.servicesLabel}</div>
            <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-950 md:text-4xl">
              {c.servicesTitle}
            </h2>
            <p className="mt-4 text-lg leading-8 text-slate-600">{c.servicesDesc}</p>
          </div>
          <div className="mt-12 grid gap-6 lg:grid-cols-3">
            {services[lang].map((service) => (
              <div key={service.title} className="rounded-[1.75rem] border border-slate-200 bg-white p-8 shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
                <div className="text-lg font-bold text-slate-950">{service.title}</div>
                <p className="mt-4 text-base leading-7 text-slate-600">{service.desc}</p>
                <div className="mt-8 text-sm font-semibold text-indigo-800">{c.serviceCta}</div>
              </div>
            ))}
          </div>
        </section>

        <section id="approach" className="bg-slate-50 py-20">
          <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-[0.95fr_1.05fr] lg:px-10">
            <div>
              <div className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-700">{c.approachLabel}</div>
              <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-950 md:text-4xl">
                {c.approachTitle}
              </h2>
              <p className="mt-4 text-lg leading-8 text-slate-600">{c.approachDesc}</p>
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
              {principles[lang].map((item, idx) => (
                <div key={item.title} className="rounded-[1.5rem] border border-slate-200 bg-white p-6 shadow-sm">
                  <div className="text-sm font-semibold text-indigo-700">0{idx + 1}</div>
                  <div className="mt-3 text-xl font-bold text-slate-950">{item.title}</div>
                  <p className="mt-3 text-sm leading-6 text-slate-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="cases" className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <div className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-700">{c.workLabel}</div>
              <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-950 md:text-4xl">
                {c.workTitle}
              </h2>
            </div>
            <div className="text-sm text-slate-500">{c.workNote}</div>
          </div>
          <div className="mt-12 grid gap-6 lg:grid-cols-3">
            {cases[lang].map((item) => (
              <div key={item.title} className="rounded-[1.75rem] border border-slate-200 bg-gradient-to-b from-white to-slate-50 p-8 shadow-sm">
                <div className="text-lg font-bold text-slate-950">{item.title}</div>
                <p className="mt-4 text-base leading-7 text-slate-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="px-6 pb-20 lg:px-10">
          <div className="mx-auto max-w-7xl rounded-[2rem] bg-indigo-950 px-8 py-12 text-white shadow-2xl shadow-indigo-950/20 md:px-12 md:py-16">
            <div className="grid gap-10 lg:grid-cols-[1fr_auto] lg:items-center">
              <div>
                <div className="text-sm uppercase tracking-[0.2em] text-white/60">{c.ctaLabel}</div>
                <h3 className="mt-4 text-3xl font-black tracking-tight md:text-4xl">{c.ctaTitle}</h3>
                <p className="mt-4 max-w-2xl text-base leading-7 text-white/75 md:text-lg">{c.ctaDesc}</p>
              </div>
              <a
                href="#contact"
                className="inline-flex items-center justify-center rounded-full bg-white px-6 py-3 text-sm font-semibold text-indigo-950 transition hover:-translate-y-0.5"
              >
                {c.ctaBtn}
              </a>
            </div>
          </div>
        </section>
      </main>

      <footer id="contact" className="border-t border-slate-200 bg-white">
        <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 lg:grid-cols-[1fr_auto] lg:px-10">
          <div>
            <div className="text-2xl font-black tracking-tight text-indigo-950">SALELARY</div>
            <p className="mt-4 max-w-xl text-base leading-7 text-slate-600">{c.footerDesc}</p>
          </div>
          <div className="grid gap-3 text-sm text-slate-600">
            <div>salelarybiz@gmail.com</div>
            <div>Seoul, Korea</div>
            <div>{c.footerAvailability}</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
